import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';

import './assets/css/reset.css'

import ScrollToTop from './components/ScrollToTop';
import ScrollToTopButton from './components/common/ScrollToTopButton';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './components/Home';
import Introduction from './components/Introduction';
import TechnologyService from './components/TechnologyService';
import Cases from './components/Cases';
import Careers from './components/Careers'
import MissionVision from './components/MissionVision'

import './App.css';

function App() {
  return (
    <Router>
    <div className="App">
      <ScrollToTop/>
      <Header />
      <div className="overflow-x-hidden">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/introduction" element={<Introduction />} />
          <Route path="/mission-vision" element={<MissionVision />} />
          <Route path="/technology" element={<TechnologyService />} />
          <Route path="/cases" element={<Cases />} />
          <Route path="/careers" element={<Careers />} />
        </Routes>
        <Footer />
      </div>
      <ScrollToTopButton />
    </div>
    </Router>
  );
}

export default App;

